// 261019 주차판 홈 — 순수 함수만(node 테스트 대상). 화면·API 는 ParkingHome.vue / ServiceLanding.vue / ParkingHomePage.vue.
// 기획서 C:/Projects/Jump/docs/1019_주차판홈_기획서.md
const CACHE_PREFIX = 'gp-parking-home:'; // 마지막 판정(앱 시작 깜빡임 방지) — 회원 번호별
const PREFS_HIDE_PREFIX = 'gp-parking-prefs-hide:'; // 설정 카드 접기 — 회원 번호별

const safe = fn => { try { return fn(); } catch (_) { return null; } }; // 사생활 보호 모드 등 저장소가 막혀도 화면은 그린다
const MODES = ['PARKING', 'NONE'];

export const readParkingHomeCache = (storage, userNo) => {
  if (!userNo) return null;
  const v = safe(() => JSON.parse(storage.getItem(CACHE_PREFIX + userNo) || 'null'));
  return v && MODES.includes(v.mode) ? v : null;
};

/** 판정(mode)만 기억한다 — 연락처·요청 메모 같은 내용은 기기에 남기지 않는다. */
export const writeParkingHomeCache = (storage, userNo, home) => {
  if (userNo && home && MODES.includes(home.mode)) safe(() => storage.setItem(CACHE_PREFIX + userNo, JSON.stringify({ mode: home.mode })));
};

/** 홈을 거치지 않고 들어온 화면(마이·/parking 바로 열기)도 같은 판정을 쓰게 — 스위치 켜짐 + 마지막 판정이 PARKING. */
export const isCachedParking = (storage, userNo, flags) => flags?.parkingHomeEnabled === true && readParkingHomeCache(storage, userNo)?.mode === 'PARKING';

export const isPrefsHidden = (storage, userNo) => !!userNo && !!safe(() => storage.getItem(PREFS_HIDE_PREFIX + userNo));

export const hidePrefs = (storage, userNo) => {
  if (userNo) safe(() => storage.setItem(PREFS_HIDE_PREFIX + userNo, '1'));
};

/** 로그아웃 — 이 기기의 주차판 홈 기억을 모두 지운다(rules/25 §1). 다른 기능 키는 건드리지 않는다. */
export const clearParkingHomeStorage = storage => {
  const keys = safe(() => Array.from({ length: storage.length }, (_, i) => storage.key(i))) || [];
  keys.filter(k => k && (k.startsWith(CACHE_PREFIX) || k.startsWith(PREFS_HIDE_PREFIX))).forEach(k => safe(() => storage.removeItem(k)));
};

/** 설정 카드 — 접었거나 동네·관심 업종을 다 정했으면 안 보인다(알림 동의는 서버가 이 응답에 담지 않아 기준에서 뺀다). */
export const needsPrefsCard = (prefs, hidden) => !hidden && !(prefs?.hasLocation === true && Number(prefs?.interestCount) > 0);

const pad = n => String(n).padStart(2, '0');

/** 요청 시간 — 오늘이면 '오늘 14:02', 어제면 '어제 14:02', 그 밖엔 '10/17 14:02'. 서버 값은 시간대 없는 ISO(서버 시간). */
export const callTimeLabel = (iso, now = new Date()) => {
  const t = iso ? new Date(String(iso)) : null;
  if (!t || Number.isNaN(t.getTime())) return '';
  const hm = `${pad(t.getHours())}:${pad(t.getMinutes())}`;
  const day = d => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const diff = Math.round((day(now) - day(t)) / 86400000);
  if (diff === 0) return `오늘 ${hm}`;
  if (diff === 1) return `어제 ${hm}`;
  return `${t.getMonth() + 1}/${t.getDate()} ${hm}`;
};

/** 거리 — 1km 미만은 10m 단위 m, 이상은 소수 한 자리 km. 값이 없으면 빈칸. */
export const distanceLabel = m => {
  const n = Number(m);
  if (m === null || m === undefined || !Number.isFinite(n) || n < 0) return '';
  if (n < 1000) return `${Math.max(10, Math.round(n / 10) * 10)}m`;
  return `${(n / 1000).toFixed(1)}km`;
};

/** 칸 제목 — 서버가 준 칸만 그린다(모르는 칸은 화면이 건너뛴다). */
export const SECTION_TITLE = {
  FLYERS: '내 동네 전단지',
  CAR: '내 차 관련 가게',
  NEARBY: '근처 간판ON 가게'
};

export const knownSections = sections => (Array.isArray(sections) ? sections : [])
  .filter(s => s && SECTION_TITLE[s.key] && Array.isArray(s.items) && s.items.length);
